module.exports = __webpack_public_path__ + "img/tu_schedule_holiday_active.d002080b.svg";